import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";

const SERVICE_LINKS = [
  { id: "pain-relief", label: "Pain Relief" },
  { id: "fat-reduction", label: "Fat Reduction" },
  { id: "gym-partnerships", label: "Gym Partnerships" },
  { id: "events-teams", label: "Sports Teams" },
  { id: "corporate-wellness", label: "Corporate Wellness" },
  { id: "chiro-pt", label: "Chiropractors/Physical Therapists" },
];

export const SiteFooter = ({ scrollToSection }) => {
  return (
    <footer className="bg-[#0a0318] border-t border-purple-400/30 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/images/imc-shield.png"
                alt="Logo"
                className="w-12 h-12 object-contain"
              />
              <div>
                <span className="block text-lg font-bold text-amber-400 whitespace-nowrap">Ice Man Cryo</span>
                <span className="block text-xs font-semibold text-amber-400 whitespace-nowrap">
                  Therapy and Wellness
                </span>
              </div>
            </div>
            <p className="text-amber-400 text-xs font-medium">Powered by America Cryo Subzero</p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <div className="space-y-2 text-sm">
              {SERVICE_LINKS.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="block text-gray-400 hover:text-amber-400"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <div className="space-y-2 text-sm">
              <button
                onClick={() => scrollToSection("meet-owner")}
                className="block text-gray-400 hover:text-amber-400"
              >
                Meet the Owner
              </button>
              <button onClick={() => scrollToSection("booking")} className="block text-gray-400 hover:text-amber-400">
                Book a Session
              </button>
              <Link to="/admin" className="block text-gray-400 hover:text-amber-400">
                Admin
              </Link>
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-2 text-gray-400">
                <MapPin className="w-4 h-4 text-amber-400" />
                <span>Midtown Atlanta, GA</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-amber-400" />
                <a href="tel:8443423626" className="text-gray-400 hover:text-amber-400">
                  844-342-3626
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-amber-400" />
                <a href="mailto:info@icemancryo.com" className="text-gray-400 hover:text-amber-400">
                  info@icemancryo.com
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-amber-500/20 text-center">
          <p className="text-gray-500 text-sm">© 2026 Ice Man Cryo Therapy & Wellness. All rights reserved.</p>
          <p className="text-gray-600 text-xs mt-2">Mobile. Targeted. No chamber. No downtime.</p>
        </div>
      </div>
    </footer>
  );
};
